import React from 'react';
import Text from '../text/Text';
import './styles.css';

export const ProjectSection = ({ project, isReversed = false }) => {
    const { title, description, titleColor } = project;

    const descriptionItems = description.map((item, index) => (
        <React.Fragment key={index}>
            {`${index + 1}. ${item}`}
            {index < description.length - 1 && <br />}
        </React.Fragment>
    ));

    const textContent = (
        <div 
            className='project-content-text' 
            id={isReversed ? 'project-content-reverse-text' : ''}
        >
            <Text as='p' fontSize={32} isBold={true} variant={titleColor}>
                {title}
            </Text>
            <Text as='p'>{descriptionItems}</Text>
        </div>
    );

    return (
        <div className='project-container'>
            <div className='project-content'>
                {/* A ordem dos elementos muda com base no `isReversed` */}
                {isReversed ? [ textContent] : [textContent]}
            </div>
        </div>
    );
};